import { isEqual } from 'lodash-es';
import { type Dispatch, type SetStateAction, useEffect, useState } from 'react';
import { type ActiveMediaTypeParams } from '../types.ts';
import { useActiveReviewsDrawerParams } from './useActiveReviewsDrawerParams.ts';

export const useActiveReviewsDrawer = (): [
  ActiveMediaTypeParams | undefined,
  Dispatch<SetStateAction<ActiveMediaTypeParams | undefined>>,
] => {
  const [activeReviewsDrawerParams, setActiveReviewsDrawerParams] = useActiveReviewsDrawerParams();

  const [activeReviewsDrawer, setActiveReviewsDrawer] = useState<ActiveMediaTypeParams | undefined>(
    activeReviewsDrawerParams,
  );

  useEffect(() => {
    if (!isEqual(activeReviewsDrawerParams, activeReviewsDrawer)) {
      setActiveReviewsDrawerParams(activeReviewsDrawer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeReviewsDrawer?.id, activeReviewsDrawer?.type]);

  useEffect(() => {
    if (!isEqual(activeReviewsDrawerParams, activeReviewsDrawer)) {
      setActiveReviewsDrawer(activeReviewsDrawerParams);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeReviewsDrawerParams?.id, activeReviewsDrawerParams?.type]);

  return [activeReviewsDrawer, setActiveReviewsDrawer];
};
